import { render, staticRenderFns } from "./shippings.vue?vue&type=template&id=0c191def"
import script from "./shippings.vue?vue&type=script&lang=js"
export * from "./shippings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports